import { LocalStorage } from '@/services/LocalStorage.ts';
import {
  enTranslation,
  frTranslation,
  i18nDefaultParams,
  isLocale,
  localesEnum,
  Logger,
  PossibleLocalesType,
} from '@arsnovasystems/ars-front-lib';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { default as projectEnTranslations } from './en_US/translation.en_US.json';
import { default as projectFrTranslations } from './fr_FR/translation.fr_FR.json';

export const availableLocales = [localesEnum.enUS, localesEnum.frFR];

const mergedResources = {
  [localesEnum.enUS]: {
    translation: {
      ...enTranslation,
      ...projectEnTranslations,
    },
  },
  [localesEnum.frFR]: {
    translation: {
      ...frTranslation,
      ...projectFrTranslations,
    },
  },
};

const initPromise = i18next
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    lng: LocalStorage.getLocale() ?? (localesEnum.enUS as PossibleLocalesType),
    resources: mergedResources,
    ...i18nDefaultParams,
  });

// Keep informations up to date with gwt
i18next.on('languageChanged', function (lng) {
  if (!isLocale(lng)) {
    Logger.warn(
      `Tried to update i18n locale with value "${lng}", but it is not a valid locale`,
    );
    return;
  }
  LocalStorage.setLocale(lng);
});

export { initPromise };
export default i18next;
